export const marketingGroupQueryKeys = {
  _base: () => ["marketingGroups"],
  all: (includeInactive: boolean) => [
    ...marketingGroupQueryKeys._base(),
    { includeInactive },
  ],
};